import { useContext, useEffect } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { Col, Row } from "reactstrap";
import { IDiskUser } from "../../app/models/repositoryUser";
import { translationHookOptions } from "../../app/localization/localization";
import { useTranslation } from "react-i18next";

interface IProps {
    diskspace?: IDiskUser;
  }
  
  const DiskUser: React.FC<IProps> = ({ diskspace }) => {
    const rootStore = useContext(RootStoreContext);
    const { resetDiskSpaceUser}= rootStore.presentationStore;
    const [t] = useTranslation(["features"], translationHookOptions);


    useEffect (() => {  
      return () => { resetDiskSpaceUser() }
    },[])
    
    // const usedPercentage = (diskspace!.currentDiskSpace / diskspace!.avaibleDiskSpace) * 100;
    // const isCritical = usedPercentage >= 90; // Se lo spazio occupato è >= 90%
  const spacefree=  diskspace!.avaibleDiskSpace-diskspace!.currentDiskSpace ;
  const spaceUsed= diskspace!.currentDiskSpace>diskspace!.avaibleDiskSpace ? diskspace!.avaibleDiskSpace : diskspace!.currentDiskSpace;
    return (
      <>
        {diskspace &&  diskspace.avaibleDiskSpace>0 &&(
         <>
        <Row>
          {/* <Col style={{ fontWeight: "bold", color: !diskspace.canUploadFile ? "red" : "black" }}>
        Spazio a disposizione: {spacefree >=0 ? spacefree : 0}/{diskspace.avaibleDiskSpace} MB
      </Col> */}
       <Col style={{ fontWeight: "bold", color: !diskspace.canUploadFile ? "red" : "black" }}>
       {t("InfoSpaceDisk")}   {spaceUsed} {t("InfoSpaceDisk2")}   {diskspace.avaibleDiskSpace} MB
      </Col>
      </Row>
         </>
         )
      }
      </>
    );
  };
  
  export default DiskUser;
  